<template>
  <section id="portfolio">
    <div class="container wow fadeInUp">
      <div>
        <div class="pro">
          <!--          <li><router-link :to="{path: `/product/${item.id}`}">{{item.name}}</router-link></li>-->
          <div class="pro_pic" v-for="(item,index) in catalog" :key="item.id">
            <!--<router-link to="/product">-->
            <router-link :to="{path: `/product/${item.id}`}">
              <img v-if="item.image"
                   v-lazy="baseImg + item.image" alt="" width="100%">
            </router-link>
            <p class="pro_text">{{item.name}}</p>
          </div>

          <div class="pro_pic">
            <a href="../../../static/2020_DOLS_EN.pdf" target="_blank">
              <img src="../../../static/logo/file.png" width="75" />
            </a>
            <p class="pro_text">Download Digital Catalog</p>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      baseImg: '/static/products/'
    }
  },
  computed: {
    ...mapState(['catalog'])
  },
  methods: {
  }
}
</script>
<style type="text/scss" rel="stylesheet/scss" lang="scss">
.pro {}
.pro_pic{
  width: 23%;
  display: inline-block;
  border: solid 1px #cccccc;
  margin-right: 5px;
  margin-bottom: 20px;
  padding: 10px 0;
  img{
    height: 110px;
    width: auto;
  }
  p{
    padding: 5px 0;
  }
  .pro_text{
    height: 30px;
  }
}
@media only screen and (max-width: 768px){
  .pro{
    overflow: hidden;
    display: flex;
    .pro_text{
      font-size: 12px;
      line-height: 30px;
    }
  }
  .pro .pro_pic{
    box-sizing: border-box;
    width: 25%;
    margin: 0 2px 10px 2px;
    padding: 5px 0;
    img{
      height: 45px;
      width: auto;
    }
  }
  .pro .pro_pic:nth-child(2n){
    /*float: left;*/
  }
  .pro .pro_pic:nth-child(2n+1){
    /*float: right;*/
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/proItem.vue